import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

export const GET_CAMPAIGNS = 'api/marketing-campaign/get-all-campaigns';

export type UtmParameter = {
  ParameterName: string;
  ParameterValue: string;
};

export type SavedMarketingSMSData = {
  CustomUtmParameters: UtmParameter[];
  IsActive: boolean;
  IsMMS: boolean;
  LeafbuyerImageTemplateId: string | null;
  LeafbuyerMessageTemplateId: string | null;
  LeafbuyerSMSMarketingConfigId: number;
  MarketingEmailTemplateId: number | null;
  MarketingSMSId: number;
  MarketingTemplatePresetId: number | null;
  Priority: number | null;
  SentMarketingEmailTemplateId: number | null;
  TotalSent: number;
  TotalToSend: number;
};

export type SavedMarketingEmailData = {
  CustomUtmParameters: UtmParameter[];
  IsActive: boolean;
  MarketingEmailId: number;
  MarketingEmailTemplateId: number | null;
  MarketingTemplatePresetId: number | null;
  MetaSenderEmail: string;
  PreviewTextLine: string;
  Priority: number | null;
  ReplyToEmail: string;
  SenderEmail: string;
  SentMarketingEmailTemplateId: number | null;
  SubjectLine: string;
  TotalSent: number;
  TotalToSend: number;
};

export type SavedMarketingPushData = {
  Body: string;
  IsActive: boolean;
  MarketingPushId: number | null;
  Priority: number | null;
  RedirectPath: string;
  Title: string;
  TotalSent: number;
  TotalToSend: number;
};

export type SavedMarketingPointBoostData = {
  Points: number;
};

export type RecipientSegment = {
  Name: string;
  SegmentId: number;
};

export type Tag = {
  MarketingTagId: number;
  TagName: string;
};

export type SavedMarketingCampaign = {
  CampaignName: string;
  CampaignStatusId: number;
  CustomUtmParameters: UtmParameter[];
  DelayInMinutes: number | null;
  DelayUnitId: number | null;
  EmailConfig: SavedMarketingEmailData | null;
  EventTypeId: number | null;
  ExternalGuid: string;
  IsAutomatedCampaign: boolean;
  IsWaterfall: boolean;
  LastModifiedDateUTC: string | null;
  LastRuntimeDateUtc: string | null;
  LspId: number;
  MarketingCampaignId: number;
  PointBoostConfig: SavedMarketingPointBoostData | null;
  PushConfig: SavedMarketingPushData | null;
  RecipientSegmentIds: number[];
  RecipientSegments: RecipientSegment[];
  ScheduleSendForUtc: string | null;
  SendToAllCustomers: boolean;
  SMSConfig: SavedMarketingSMSData | null;
  TagIds: number[];
  Tags: Tag[];
  TimeOfDayToSend: string | null;
};

export type GetCampaignV2Response = {
  Campaign: SavedMarketingCampaign;
  DailyMaxEmailCapacity: number | null;
  EmailsSentToday: number | null;
};

export type GetMarketingCampaignsResult = SavedMarketingCampaign[];

export const marketingCampaignsQueryKey = ['marketing-campaigns'];

export function useGetMarketingCampaignsQuery() {
  return useQuery({
    queryKey: marketingCampaignsQueryKey,
    queryFn: () => fetchData<GetMarketingCampaignsResult>(GET_CAMPAIGNS),
    staleTime: Infinity,
  });
}
